import React from 'react';
import _ from 'lodash';
import { Redirect, withRouter } from 'react-router'; // import the react-router-dom components
import { AuthRoles } from '../../config';
import NavigationConfig from '../../navigation/config';
// import { SideBarConfig } from '../../navigation/config/Routes';
import { ReducerKeys } from '../../redux/reducers';
import { getState } from '../../redux/store';

const MainPage = (props: any) => {
  // console.log('Render MainPage');

  // replace main page with login Page
  if (
    _.get(getState(ReducerKeys.AUTH_REDUCER), 'role', AuthRoles.Guest) ===
    AuthRoles.Guest
  ) {
    return <Redirect to={NavigationConfig.loginPage().path} />;
  } else {
    return <Redirect to={NavigationConfig.dashboardPage().path} />;
  }
};

export default withRouter(MainPage);
